<template>
  <default>
    <div class="claims-page">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <header class="claims-header">
        <div>
          <h1 class="claims-title">Make a claim</h1>
          <p class="claims-subtitle">Online claims are coming soon. You can still view your policies anytime.</p>
        </div>
        <router-link :to="{ name: 'MyPolicies' }" class="claims-link">
          <v-icon small color="#184679">mdi-shield-check-outline</v-icon>
          My policies
        </router-link>
      </header>

      <div class="claims-type-grid">
        <button
          v-for="type in coverTypes"
          :key="type.id"
          type="button"
          class="claims-type-card claims-type-card--soon"
          disabled
        >
          <div class="claims-type-card__icon" :style="{ background: type.iconBg }">
            <v-icon :color="type.accent" size="28">{{ type.icon }}</v-icon>
          </div>
          <div class="claims-type-card__body">
            <h3>{{ type.label }}</h3>
            <p>{{ type.description }}</p>
            <span class="claims-soon-badge">Coming soon</span>
          </div>
        </button>
      </div>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';

export default {
  name: 'ClaimDetails',
  components: {
    BreadCrumb,
    Default,
  },
  data() {
    return {
      breadcrumbs: [
        { text: 'Dashboard', disabled: false, to: { name: 'Dashboard' } },
        { text: 'Make A Claim', disabled: true, to: { name: 'Claims' } },
      ],
      coverTypes: [
        {
          id: 'motor',
          label: 'Motor',
          description: 'Accident, theft and windscreen claims',
          icon: 'mdi-car-outline',
          accent: '#184679',
          iconBg: 'linear-gradient(135deg, #E8EEF5 0%, #F0F4F8 100%)',
        },
        {
          id: 'domestic',
          label: 'Domestic Package',
          description: 'Home and contents claims',
          icon: 'mdi-home-circle-outline',
          accent: '#EA580C',
          iconBg: 'linear-gradient(135deg, #FFEDD5 0%, #FFF7ED 100%)',
        },
        {
          id: 'medical',
          label: 'Medical',
          description: 'Reimbursement claims for Pacis Amani',
          icon: 'mdi-heart-pulse',
          accent: '#0d9488',
          iconBg: 'linear-gradient(135deg, #CCFBF1 0%, #F0FDFA 100%)',
        },
      ],
    };
  },
};
</script>

<style scoped>
.claims-page {
  width: 100%;
}

.claims-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 1.25rem 0 1.5rem;
  flex-wrap: wrap;
}

.claims-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.claims-subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: #64748b;
  max-width: 36rem;
}

.claims-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #184679;
  text-decoration: none;
  padding: 8px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
}

.claims-type-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 1.5rem;
}

@media (min-width: 768px) {
  .claims-type-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.claims-type-card {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  text-align: left;
  padding: 1rem 1.125rem;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.claims-type-card--soon {
  opacity: 0.92;
  cursor: default;
}

.claims-soon-badge {
  display: inline-block;
  margin-top: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #64748b;
  background: #f1f5f9;
}

.claims-type-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.claims-type-card__body {
  flex: 1;
  min-width: 0;
}

.claims-type-card__body h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: #1e4276;
}

.claims-type-card__body p {
  margin: 4px 0 0;
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.4;
}

.claims-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.25rem 1.25rem 1.5rem;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .claims-section {
    padding: 1.5rem 1.75rem 1.75rem;
  }
}

.claims-section--info {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #64748b;
  font-size: 0.9rem;
}

.claims-section__title {
  margin: 0 0 6px;
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e4276;
}

.claims-section__hint {
  margin: 0 0 1.25rem;
  font-size: 0.875rem;
  color: #64748b;
}

.claims-forms-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 768px) {
  .claims-forms-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.claims-form-card {
  padding: 1.125rem;
  background: #f8fafc;
  border: 1px solid #eef2f6;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.claims-form-card h3 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e4276;
  flex: 1;
}

.claims-alert {
  margin-bottom: 1.25rem;
}

.claims-upload-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 768px) {
  .claims-upload-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .claims-upload-grid--single {
    grid-template-columns: 1fr;
    max-width: 480px;
  }
}

.claims-submit {
  max-width: 420px;
  margin: 1.5rem auto 0;
}
</style>
